module.exports = new __parcel__URL__("10380037-2.bf51e171.png").toString();